import { render, staticRenderFns } from "./IconPublicLearning.vue?vue&type=template&id=01084f84"
import script from "./IconPublicLearning.vue?vue&type=script&lang=js"
export * from "./IconPublicLearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports